<script setup>
import PartyFlag from '@/components/PartyFlag'
import { computed } from 'vue'

const props = defineProps({
  data: Object,
  small: Boolean,
})

const name = computed(() => {
  // return props.data.name.replace(' ', '<br> ')
  // if (props.data.name.length > 13) {
  //   return props.data.name.replace(' ', '<br> ')
  // }
  return props.data.name
})
</script>

<template>
  <InertiaLink
    :href="`/kandidati/${props.data.slug}`"
    class="group flex flex-col items-center justify-start gap-4"
  >
    <div
      class="relative transition-all duration-200 group-hover:-translate-y-1"
    >
      <img
        v-lazy="props.data?.image?.url"
        :alt="props.data.name"
        class="h-[100px] w-[100px] overflow-hidden rounded-full bg-white object-cover object-center shadow-2xl"
      />
      <PartyFlag
        class="absolute top-1/2 right-0 translate-x-2/3 -translate-y-1/2 px-3 py-0.5 text-sm"
        :data="props.data.party"
      />
    </div>

    <h3
      class="text-center text-base font-extrabold uppercase !leading-snug lg:text-lg"
      v-html="name"
      :class="{
        'w-[130px] lg:w-[135px]': small,
        'w-[130px] lg:w-[170px]': !small,
      }"
    ></h3>
  </InertiaLink>
</template>
